import Lexer from './lexer/lexer';

export const Definitions: any = () => {
  const ld = Lexer.definition();
  ld.define('default', 'default');
  ld.define('boolean', 'true');
  ld.define('boolean', 'false');
  ld.define('integer', '[0123456789][0123456789]*');
  ld.define('string', '[a-zA-Z_][a-zA-Z0-9_]*');
  ld.define('if_start', '{{#if ');
  ld.define('if_end', '{{/if}}');
  ld.define('mustache_start', '{{');
  ld.define('mustache_end', '}}');
  ld.define('space', ' ');
  ld.define('header', ['#', '##', '###']);
  ld.define('block', ['> ', ' > ', '  > ']);
  ld.define('element_start', ['<', '&lt;']);
  ld.define('element_end', ['>', '&gt;']);
  ld.define('list_unordered', [
    '- ', // 0 spaces
    '  - ', // 2 spaces
    '    - ', // 4 spaces
    '      - ', // 6 spaces
    '        - ', // 8 spaces
    '          - ', // 10 spaces
    '            - ', // 12 spaces
  ]);
  ld.define('list_ordered', [
    '[0123456789][0123456789]. ', // 0 spaces multiple numbers (10.)
    '[0123456789]. ', // 0 spaces single number (1.)
    '  [0123456789]. ', // 2 spaces single number (1.)
    '    [0123456789]. ', // 4 spaces single number (1.)
    '      [0123456789]. ', // 6 spaces single number (1.)
    '        [0123456789]. ', // 8 spaces single number (1.)
    '          [0123456789]. ', // 10 spaces single number (1.)
    '            [0123456789]. ', // 12 spaces single number (1.)
  ]);
  ld.define('new_line', '\n');
  ld.defineText('table', '|', '|\n');
  ld.define('operator', [
    '+',
    '/',
    '=',
    '==',
    '===',
    '^',
    '!',
    '|',
    '||',
    '&',
    '&&',
  ]);
  ld.defineText('bold_italic', '***', '***');
  ld.defineText('bold', '**', '**', {
    escape: '*',
    escaped: { '*': '*' },
  });
  ld.defineText('image_link', '![', ')');
  ld.defineText('url_link', '<a ', '</a>');

  return ld;
};
